import { useEffect, useState } from "react";
import TrialTranscriptionModal from "../TrialTranscriptionModal";
import Header from "../Header";
import DashboardSidebar from "../Sidebar";
import Footer from "../Footer";
import CreateAlertModal from "./CreateAlertModal";
import HttpManager from "../../utils/HttpManager";
import { Navigate, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

function Alerts() {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(true); // Add loading state
    const [showModal, setShowModal] = useState(false);
    const [sectionName, useSectionName] = useState("Alerts");
    const [useSubscriptions, setUseSubscriptions] = useState([]);
    const [userSubscriptionAlerts, setUserSubscriptionAlerts] = useState([]);

    useEffect(() => {
        setUseSubscriptions(JSON.parse(localStorage.getItem("UserSubscriptions")));

        // Fetch subscription data from the server
        async function fetchSubscriptionAlerts() {
            try {
                const response = await new HttpManager(navigate).get("/Alerts/GetAll");
                console.log("Subscriptions:", response);
                setUserSubscriptionAlerts(response.Data);
            } catch (error) {
                console.error("Error fetching subscriptions alerts:", error);
            } finally {
                setTimeout(() => setLoading(false) // Mark loading complete
                    , 3000);
            }
        }

        fetchSubscriptionAlerts();
    }, [])


    return (
        <>
            <div className="container-fluid px-5 py-2">
                <Header />
                <main className="row" style={{ minHeight: "65vh" }}>
                    <DashboardSidebar useSectionNameFn={useSectionName} />

                    <div className="container-dashboard px-4 py-2" id="featured-3">
                        <div className="row  row-cols-2 row-cols-lg-2 border-bottom">

                            <h2 className="pb-2 float-start text-start">
                               Alerts
                            </h2>
                            {/* <h4 className="pb-2 float-end text-end  text-primary" style={{ cursor: "pointer" }} >
                                <button type="button" className="btn btn-outline-primary btn-lg px-4" onClick={() => setShowModal(true)}>Demo</button>
                            </h4> */}
                        </div>
                        <div className="feature offset-10 col-2 col-center mt-5">
                            <button type="button" className="btn btn-outline-primary btn-lg px-4 d-flex justify-content-between align-items-center mb-0 mx-auto" onClick={() => setShowModal(true)}>
                                <span className="d-flex align-items-center" style={{ cursor: "pointer" }}>
                                    <i class="fa fa-plus text-outline-primary me-2"> </i>
                                </span>
                                Create Alert
                            </button>

                            {/* <div className="card shadow-sm">
                                <div className="card-body placeholder-glow" style={{ background: "#21252908" }}>
                                    <div className="row">
                                        <div className="col-4">
                                            <GetSubscriptionDropdown UserSubscriptions={userSubscriptions} />
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                        {
                            loading ?
                                <ActiveSubscriptionSkeletonCard />
                                 :
                                (userSubscriptionAlerts === null || userSubscriptionAlerts === undefined || userSubscriptionAlerts.length === 0) ?
                                    <div className="row g-4 py-5 row-cols-1 row-cols-lg-1">
                                        <div className="text-center">
                                            <h3 className="text-body-emphasis">No Active Subscription Alerts</h3>
                                            <p className="text-body-secondary">You don't have any active subscription alerts. Please subscribe to a plan to use the service.</p>
                                            <Link to="/Pricing" className="btn btn-primary">Checkout Subscription</Link>
                                        </div>
                                    </div> :

                                    (
                                        <div className="row row-cols-2 row-cols-sm-2 row-cols-md-4 g-5 px-5">
                                            {
                                                userSubscriptionAlerts.map((subscriptionAlert, index) => (
                                                    <GetSubscriptionAlertCards SubscriptionAlertData={subscriptionAlert} />
                                                ))
                                            }
                                        </div>
                                    )
                        }
                        {
                            showModal && (<CreateAlertModal setShowModal={setShowModal} />)
                        }
                    </div>
                </main >

                <Footer />
            </div >
        </>
    )

}

function GetSubscriptionDropdown(props) {

    const [chartType, setChartType] = useState("area");

    return (
        <select id="drpChartType" className="form-select" value={chartType} onChange={(e) => { setChartType(e.target.value) }}>
            <option >Select Subscription</option>
            {
                props.UserSubscriptions.map((subcription) => (
                    <option value={subcription.UserSubscriptionID}>{subcription.SubscriptionName}</option>
                ))
            }
        </select>
    )
}

function GetSubscriptionAlertCards({ SubscriptionAlertData }) {
    const navigate = useNavigate();

    return (
        <div className="feature col mt-5">
            <div class="card shadow-sm">

                <div class="card-header d-flex justify-content-between align-items-center">
                    <h5 class="mb-0 mx-auto ">{SubscriptionAlertData.AlertType}</h5>
                </div>
                <div class="card-body">
                    {/* <h3 className="card-title fs-2 text-body-emphasis">{SubscriptionData.SubscriptionData.SubscriptionName}</h3> */}
                    <ul class="mt-1 mb-0">
                        <li className="text-body-primary"><strong>{SubscriptionAlertData.SubscriptionName}</strong></li>

                        {
                            SubscriptionAlertData.AlertFrequency && 
                            <li className="text-body-secondary">Frequency: {SubscriptionAlertData.AlertFrequency}</li>
                        }

                        {
                            SubscriptionAlertData.SubscriptionName === "Surge" &&
                            <li className="text-body-secondary">{SubscriptionAlertData.SurgeRatio}%</li>
                        }

                        <li className="text-body-secondary">Alert Status: 
                            {
                                !SubscriptionAlertData.IsActive ? 
                                <strong className="text-danger"> Not-Active</strong>
                                :
                                <strong className="text-primary"> Active</strong>
                                
                            }

                        </li>
                        <br />
                    </ul>
                </div>
            </div>
        </div>
    );
}

function ActiveSubscriptionSkeletonCard() {
    return (
        <div className="feature col-3 ">
            <div class="card shadow-sm">
                <h5 class="card-header text-center placeholder-glow">
                    <span className="placeholder col-5"></span>
                </h5>
                <div class="card-body placeholder-glow">
                    <ul class="list-unstyled mt-1 mb-0">
                        <li className="placeholder col-5"></li>
                        <br />
                        <li className="placeholder col-8"></li>
                        <br />
                    </ul>
                </div>
                {/* <div class="card-footer text-body-secondary px-3 py-3 text-center col placeholder-glow">
                    <span className="text-primary placeholder col-6"></span><br /><strong className=" placeholder col-8"></strong>
                </div> */}
            </div>
        </div>
    );
}

export default Alerts;